import { Factory } from "@/data/dao/Factory";
import { UserDao } from "@/data/dao/service/UserDao";
import type { IIdentity } from "@/data/model/User";
import { exceptionTypes } from "@/data/util/Config";



import { i18n } from "@/portal/Trans";
import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { SetUserPasswordForm } from "@/portal/forms/SetUserPasswordForm";
import { UserAccessEditor } from "@/portal/forms/UserAccessEditor";
import { UserForm } from "@/portal/forms/UserForm";
import { UserOperatorSettingsForm } from "@/portal/forms/UserOperatorSettingsForm";
import { UiNotification } from "@/portal/ui/Notification";


export class UserController extends BaseTabbedController<IIdentity> {
    private userForm: UserForm;
    private accessEditor?: UserAccessEditor;
    private operatorSettings?: UserOperatorSettingsForm;
    private pwResetForm?: SetUserPasswordForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance(UserDao));

        this.userForm = new UserForm(this.formContentByTabName("useredit"));
        this.userForm.onSaved = async (model) => {
            location.reload();
        }
        this.userForm.onCreateError = (error) => {
            if (error.type === exceptionTypes.emailInUseException) {
                UiNotification.showException(i18n("login.emailAlreadyUsed"));
            } else {
                let message = this["resolveErrorMessage"] !== undefined
                        ? this["resolveErrorMessage"]("create", error)
                        : undefined;
                if (message === undefined) {
                    message = i18n("general.failedCreate");
                }
                UiNotification.showException(message);
            }
        };

        this.registerModelForm(this.userForm);

        this.onActivateTab = (newTab) => {
            switch (newTab) {
                case "access":
                    this.showAccess();
                    break;
                case "operator-settings":
                    this.showOperatorSettings();
                    break;
                case "resetpass":
                    this.showPasswordReset();
                    break;
                case "history":
                    break;
            }
        };
    }

    protected onModelLoaded(m?: IIdentity) {
        if (m === undefined) {
            this.disableTabs(["access", "operator-settings", "resetpass", "history"]);
        } else {
            if (m.user !== undefined) {
                this.enableTabs(["access", "operator-settings", "resetpass"]);
            }

            this.enableTab("history");
        }

        this.userForm.setData(m);
    }

    private async showAccess() {
        if (this.accessEditor === undefined)
            this.accessEditor = new UserAccessEditor(this.formContentByTabName("access"));

        this.accessEditor.loadForUser(this.entityId!);
    }

    private showOperatorSettings() {
        if (this.operatorSettings === undefined)
            this.operatorSettings = new UserOperatorSettingsForm(this.formContentByTabName("operator-settings"));

        this.operatorSettings.loadForUser(this.entityId!);
    }

    private showPasswordReset() {
        if (this.pwResetForm === undefined)
            this.pwResetForm = new SetUserPasswordForm(this.formContentByTabName("resetpass"), this.model!.id);
    }
}
